import { useGetExternalIntegrationsQuery } from '@Queries/Integrations/useGetExternalIntegrations';
import * as Api from '@ViewModels';
import { CATEGORY_SYNC_PROVIDERS, getCategorySyncState } from './TagsUtilities';

/** Whether an integration sync owns a category, checked against the account's enabled integrations */
export const useCategorySync = (impersonationContext?: Api.IImpersonationContext) => {
	const { data } = useGetExternalIntegrationsQuery({
		impersonationContext,
		toastErrorMessage: "Couldn't load integrations, so synced tag categories stay read-only",
	});
	// A failed refetch keeps the last good list in `data`, so the last known state holds until it recovers
	const enabledProviders = data
		? new Set(data.filter(integration => integration.enabled).map(integration => integration.provider))
		: null;
	return {
		getCategorySync: (category?: Api.ITagCategory | null) => getCategorySyncState(category, enabledProviders),
		/** False once the integrations show no category sync is on, so no category can be locked */
		canLockCategories:
			!enabledProviders || Object.values(CATEGORY_SYNC_PROVIDERS).some(provider => enabledProviders.has(provider)),
	};
};
